<template>
	<div>
		<div v-if="showPopup" class="registerSuccessOrReject-modal-backdrop">
			<div class="registerSuccessOrReject-container text-center">
				<div class="text-center">
					<img src="@/assets/new-web/modal-rejected-icon.svg" alt />
				</div>
				<div class="mt-3 email-exists-font">
					{{ invalidText }}
				</div>
				<div v-if="candExists" class="mt-2 email-exists-sub-font">
					Please Login to continue
				</div>
				<div v-else class="mt-2 email-exists-sub-font">Please try again</div>
				<div></div>
			</div>
		</div>
		<div v-else-if="registered" class="registerSuccessOrReject-modal-backdrop">
			<div class="registerSuccessOrReject-container text-center">
				<div class="text-center">
					<img src="@/assets/new-web/modal-success-icon.svg" alt />
				</div>
				<div class="regis-success-font">{{ successText }}</div>
				<div></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Popupcomponent",
	props: {
		registered: Boolean,
		showPopup: Boolean,
		invalidText: String,
		candExists: Boolean,
		successText: String,
	},
};
</script>

<style scoped>
/* Styles for the modal backdrop */
.registerSuccessOrReject-modal-backdrop {
	position: absolute;
	top: 0;
	left: 0 !important;
	width: calc(100% + 35px) !important;
	height: 100% !important;
	background-color: rgba(0, 0, 0, 0.2);
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 40px !important;
	z-index: 4;
}

@media (max-width: 1028px) {
	.registerSuccessOrReject-modal-backdrop {
		left: 0 !important;
		width: 100% !important;
		border-radius: 38px 38px 0 0 !important;
	}
}

.registerSuccessOrReject-container {
	background: #fff;
	border-radius: 16px;
	padding: 20px;
	width: 231.59px;
	position: relative !important;
	left: auto !important;
	top: auto !important;
	transform: none !important;
}

.regis-success-font {
	font-family: "Inter", sans-serif;
	font-weight: 500;
	font-size: 14px;
	text-align: center;
	color: #667085;
}

.email-exists-font {
	font-family: "Inter", sans-serif;
	font-weight: 500;
	font-size: 14px;
	color: #667085;
}

.email-exists-sub-font {
	font-family: "Inter", sans-serif;
	font-weight: 400;
	font-size: 12px;
	color: #667085;
}
</style>
